module.exports = __webpack_public_path__ + "img/Orange-lined triggerfish.4153995b.png";